<!--签署提示公共组件-->
<template>
    <div class="attention">
        <template v-if="codeStatus===1">
            <div class="anticon type-success"></div>
            <div class="type-success-text">新增签名成功</div>
        </template>
        <!-- 暂不考虑 -->
        <template v-if="codeStatus===2">
            <div class="anticon type-warn"></div>
            <div class="type-warn-text">二维码失效</div>
        </template>
        <template v-if="codeStatus===0">
            <div class="anticon type-fail"></div>
            <div class="type-fail-text">新增签名失败</div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        codeStatus: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data () {
        return {
            mt: 220
        };
    },
    mounted: function () {
        // console.info(document.body.clientHeight);
        // this.mt = document.body.clientHeight / 2 - 43;
    } //初始化数据
};
</script>

<style lang="less" scoped>
.attention {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    .anticon {
        font-size: 62px;
        display: block;
    }
    .type-success {
        margin-bottom: 4px;
        color: #53fe71;
        &:before {
            content: "\2714";
        }
    }

    .type-fail {
        margin-bottom: 4px;
        color: #fe5c53;
        &:before {
            content: "\2716";
        }
    }
    .type-warn {
        margin-bottom: 4px;
        color: #fe5c53;
        &:before {
            content: "\00A1";
        }
    }
}
</style>
